import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateDeleteAssetsOperationMutationVariables = Types.Exact<{
  input: Types.CreateDeleteAssetsOperationInput;
}>;


export type CreateDeleteAssetsOperationMutation = { __typename?: 'Mutation', createDeleteAssetsOperation?: { __typename?: 'CreateDeleteAssetsOperationPayload', assetOperation?: { __typename?: 'CopyAssetsOperation', id?: string | null } | { __typename?: 'DeleteAssetsOperation', id?: string | null } | { __typename?: 'HardDeleteAssetsOperation', id?: string | null } | { __typename?: 'MoveAssetsOperation', id?: string | null } | { __typename?: 'UpdateAssetFieldValuesOperation', id?: string | null } | null } | null };


export const CreateDeleteAssetsOperation = /*#__PURE__*/ gql`
    mutation CreateDeleteAssetsOperation($input: CreateDeleteAssetsOperationInput!) {
  createDeleteAssetsOperation(input: $input) {
    assetOperation {
      id
    }
  }
}
    ` as unknown as DocumentNode<CreateDeleteAssetsOperationMutation, CreateDeleteAssetsOperationMutationVariables>;

          

          export const useCreateDeleteAssetsOperationMutation = (options?:MutationHookOptions<CreateDeleteAssetsOperationMutation, CreateDeleteAssetsOperationMutationVariables>) => useMutation(CreateDeleteAssetsOperation, options);
          

          export type CreateDeleteAssetsOperationMutationOptions = MutationHookOptions<CreateDeleteAssetsOperationMutation, CreateDeleteAssetsOperationMutationVariables>;

          

          export type CreateDeleteAssetsOperationMutationResult = ReturnType<typeof useCreateDeleteAssetsOperationMutation>[1];

          
